import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { RequestsService } from '@api/services/requests.service';
import { MODAL_REF, ModalRef, ModalService } from '@ui/modal/modal.service';
import { FileUploadComponent } from '@ui/file-upload/file-upload.component';
import { ModalComponent } from '@ui/modal/modal.component';
import { forkJoin } from 'rxjs';
import { AppService } from '../../../app.service';
import { LoadingService } from '@ui/app-layout/loading-service';

@Component({
  selector: 'app-upload-documents-modal',
  standalone: true,
  imports: [
    CommonModule,
    ModalComponent,
    ReactiveFormsModule,
    FileUploadComponent,
  ],
  template: `
    <ui-modal
      [title]="'Documenten uploaden'"
      [submitText]="'Uploaden'"
      [cancelText]="'Annuleren'"
      (close)="closeModal()"
      (save)="saveModal()"
    >
      <form [formGroup]="uploadForm" class="space-y-6">
        <ui-file-upload
          formControlName="files"
          [multiple]="true"
          accept=".pdf,.doc,.docx"
          helperText="Toegestane bestandstypen: PDF, DOC, DOCX (max 10MB)"
        ></ui-file-upload>
      </form>
    </ui-modal>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UploadDocumentsModalComponent {
  @Input() requestId!: string;

  private fb = inject(FormBuilder);
  private modalRef = inject(MODAL_REF);
  private modalService = inject(ModalService);
  private requestsService = inject(RequestsService);
  private appService = inject(AppService);
  private loadingService = inject(LoadingService);

  uploadForm = this.fb.group({
    files: [[] as File[]],
  });

  closeModal() {
    this.modalService.close(this.modalRef as ModalRef<any>);
  }

  saveModal() {
    const files = this.uploadForm.get('files')?.value;

    if (files?.length) {
      const uploadOperations = files.map(file =>
        this.requestsService.createRequestAttachment(this.requestId, file)
      );

      this.loadingService.show();
      forkJoin(uploadOperations).subscribe({
        next: () => {
          console.log('All files uploaded successfully');
          this.loadingService.hide();
          this.modalService.close(this.modalRef as ModalRef<any>);
        },
        error: (error) => {
          console.error('Error uploading files:', error);
          this.loadingService.hide();
        }
      });
    }
  }
}
